import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import STATUS_TAB from '@/data/statusTab.json'
import { X } from 'lucide-react'
import React from 'react'

type OrderFilterType = {
    handleFilter: (e: React.FormEvent<HTMLFormElement>) => void
    handleBarcodeChange: (event: React.ChangeEvent<HTMLInputElement>) => void 
    handleReset: () => void
    barcode: string
    statusOrder: string
    setStatusOrder: React.Dispatch<React.SetStateAction<string>>
    loadSpinner: boolean
}

export default function OrderFilter({orderFilterProps}: {orderFilterProps: OrderFilterType}) {
    const {
      handleFilter,
      handleBarcodeChange,
      handleReset,
      barcode,
      statusOrder,
      setStatusOrder,
      loadSpinner,
    } = orderFilterProps
   
   const disabledButton = statusOrder === '' && barcode === ''

    return (
        <Form onSubmit={handleFilter}>
        <Row className='d-flex align-items-center py-3 '>
          <Col xs={6} md={3} className='col-3 bg-transparent'>
            <Form.Control
              type='text'
              placeholder='Barcode'
              className='rounded'
              value={barcode}
              onChange={handleBarcodeChange}
            />
          </Col>
          <Col xs={6} md={3} className='col-3 bg-transparent'>
            <Form.Select
              aria-label='Default select example'
              className='form-control rounded'
              value={statusOrder}
              onChange={(e) => setStatusOrder(e.target.value)}
            >
              <option value=''>-- Statut --</option>
              {STATUS_TAB.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col className='d-flex flex-row align-items-center gap-2 mt-2 mt-md-0'>
            <Button
              type='submit'
              variant='outline-warning'
              className='d-flex align-items-center rounded-3 gap-2'
              disabled={disabledButton}
            >
              {loadSpinner && <Spinner size='sm' />}
              Filtrer
            </Button>
            {(barcode !== '' || statusOrder !== '') && (
              <Button variant='link' onClick={handleReset}>
                <X size={20} />
                réinitialiser
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    )
}